import Vue from 'vue';

Vue.filter('algoliaProcessedCurrency', value => {
    let decimalValue = parseInt(value).toFixed(2);
    let processedValue = decimalValue.toString();
    return (processedValue).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
});